/* eslint-disable react/no-multi-comp, react/prop-types */

import { Field } from 'redux-form';
import { connect } from 'react-redux';
import React from 'react';
import _ from 'lodash';

import {
  ACH_STATUSES,
  BILLING_STATUSES,
  DEPARTMENTS,
  INVOICE_METHODS,
  INVOICE_STATUSES,
  PAYMENT_METHODS,
  PAYMENT_STATUSES,
  PERSON_STATUSES,
  PURCHASE_ORDER_STATUSES,
  STATUSES,
  TICKET_STATUSES,
  TICKET_TYPES,
  TRIAGE_STATUSES,
  TRIAGE_TYPES
} from 'constants';
import {
  AgreementSelect,
  CompanySelect,
  PersonSelect,
  TeamSelect,
  TicketSelect,
  UserSelect,
  VendorSelect
} from 'components/forms/selects';
import {
  RenderArrayFilter,
  RenderCompanyFilter,
  RenderDateFilter,
  RenderFilter,
  RenderMappedArrayFilter,
  RenderTeamFilter,
  RenderUserFilter
} from 'utils/filter-utils';
import { Row } from 'components/forms/form-structure';
import { TextInput, DateInput, CheckboxGroupInput } from 'components/forms/form-elements';
import { convertArrayToOptions } from 'utils/input-utils';
import AgreementData from 'services/data/agreement';


// Components
export default function DefaultFilter(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label={props.label} />;

  return (
    <Field component={TextInput} {...props} />
  );
}

/**
 * General filters
 */
export function Search(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Search" />;

  return (
    <Field label="Search" placeholder="search" component={TextInput} {...props} />
  );
}

export function Id(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Id" />;

  return (
    <Field component={TextInput} {...props} label="Id" />
  );
}

export function Date({ label = 'Date Between', valueLabel = 'Date', name, ...props }) {
  if (props.renderValue) return <RenderDateFilter values={props.renderValue} label={valueLabel} />;

  return (
    <Row label={label}>
      <Field component={DateInput} {...props} name={`${name}.min`} rightAlignPicker />
      <Field component={DateInput} {...props} name={`${name}.max`} rightAlignPicker />
    </Row>
  );
}

export function ReleaseDate(props) {
  return <Date {...props} label="Release Date Between" valueLabel="Release Date" />;
}

export function StartDate(props) {
  return <Date {...props} label="Start Date Between" valueLabel="Start Date" />;
}

export function EndDate(props) {
  return <Date {...props} label="End Date Between" valueLabel="End Date" />;
}

export function Ticket(props) {
  if (props.renderValue) return <RenderFilter value="(selected)" label="Ticket" />;

  return (
    <Field component={TicketSelect} {...props} label="Ticket" />
  );
}

export function Company(props) {
  if (props.renderValue) return <RenderCompanyFilter values={props.renderValue} label="Company" />;

  return (
    <Field component={CompanySelect} {...props} label="Company" placeholder="select company..." />
  );
}

export function Agreement({ ...props }) {
  if (props.renderValue) return <RenderFilter value="(selected)" label="Agreement" />;

  return (
    <Field component={AgreementSelect} {...props} label="Agreement" setDefaultAgreement={false} searchParams={AgreementData.activeQuery} />
  );
}

export function Vendor(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Vendor" />;

  return (
    <Field component={VendorSelect} {...props} label="Vendor" config={{ tags: false }} />
  );
}

export function Team(props) {
  if (props.renderValue) return <RenderTeamFilter value={props.renderValue} label="Company Team" />;

  return (
    <Field component={TeamSelect} {...props} label="Company Team" />
  );
}

export function CompanyType({ name, ...props }) {
  const options = ['Client', 'Contact'];

  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Company Type" options={options} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Company Type" options={convertArrayToOptions(options)} />;
}

export function PrimaryTech({ ...props }) {
  if (props.renderValue) return <RenderUserFilter values={props.renderValue} label="Primary Tech" />;

  return (
    <Field component={UserSelect} {...props} label="Primary Tech" multi />
  );
}

export function DueDate(props) {
  return <Date {...props} label="Due Date Between" valueLabel="Due Date" />;
}

export function TaskRecurrence({ name, ...props }) {
  const options = ['Recurring tasks', 'Non-recurring tasks'];

  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Task Recurrence" options={options} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Task Recurrence" options={convertArrayToOptions(options)} />;
}


/**
 * Invoice filters
 */
export function InvoiceDate(props) {
  return <Date {...props} label="Invoice Date Between" valueLabel="Invoice Date" />;
}

export function PersonStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Status" options={PERSON_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Status" options={convertArrayToOptions(PERSON_STATUSES)} />;
}

export function Status({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Status" options={STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Status" options={convertArrayToOptions(STATUSES)} />;
}

function TagsFilter({ name, settings, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Tags" options={settings.personTags} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Tags" options={convertArrayToOptions(settings.personTags)} />;
}

export const Tags = connect(state => ({
  settings: state.pageData.settings
}))(TagsFilter);

export function InvoiceStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Delivery Status" options={INVOICE_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Delivery Status" options={convertArrayToOptions(INVOICE_STATUSES)} />;
}

export function AchStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="ACH Status" options={INVOICE_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="ACH Status" options={convertArrayToOptions(ACH_STATUSES)} />;
}

export function BillingStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Status" options={BILLING_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Status" options={convertArrayToOptions(BILLING_STATUSES)} />;
}

export function PaymentMethod({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Payment Method" options={PAYMENT_METHODS} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Payment Method" options={convertArrayToOptions(PAYMENT_METHODS)} />;
}

export function PaymentStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Payment Status" options={PAYMENT_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Payment Status" options={convertArrayToOptions(PAYMENT_STATUSES)} />;
}

export function InvoiceMethod({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Invoice Method" options={INVOICE_METHODS} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Invoice Method" options={convertArrayToOptions(INVOICE_METHODS)} />;
}

export function Department({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Department" options={DEPARTMENTS} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Department" options={convertArrayToOptions(DEPARTMENTS)} />;
}


/**
 * Expense filters
 */
export function PurchaseOrderStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Purchase Order Status" options={PURCHASE_ORDER_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Purchase Order Status" options={convertArrayToOptions(PURCHASE_ORDER_STATUSES)} />;
}

export function PurchasedBy(props) {
  if (props.renderValue) return <RenderUserFilter values={props.renderValue} label="Purchased By" />;

  return (
    <Field component={UserSelect} {...props} label="Purchased By" multi />
  );
}

/**
 * Triage filters
 */
export function TriageType({ name, ...props }) {
  const options = _.map(TRIAGE_TYPES, type => ({
    value: _.toLower(_.replace(type, / /g, '')),
    label: type
  }));

  if (props.renderValue) return <RenderMappedArrayFilter values={props.renderValue} label="Triage Type" options={options} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Triage Type" options={options} />;
}

export function TriageStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Triage Status" options={TRIAGE_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Triage Status" options={convertArrayToOptions(TRIAGE_STATUSES)} />;
}

export function ClaimedBy({ ...props }) {
  if (props.renderValue) return <RenderUserFilter values={props.renderValue} label="Claimed By" />;

  return (
    <Field component={UserSelect} {...props} label="Claimed By" multi />
  );
}

export function Contact({ ...props }) {
  if (props.renderValue) return <RenderFilter value={`(${props.renderValue.length} selected)`} label="Contact" />;

  return (
    <Field component={PersonSelect} {...props} label="Contact" multi />
  );
}

export function Subject(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Email Subject" />;

  return (
    <Field component={TextInput} {...props} label="Email Subject" />
  );
}

export function From(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Email From" />;

  return (
    <Field component={TextInput} {...props} label="Email From" />
  );
}

export function Trigger(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Alert Trigger" />;

  return (
    <Field component={TextInput} {...props} label="Alert Trigger" />
  );
}

export function Hostname(props) {
  if (props.renderValue) return <RenderFilter value={props.renderValue} label="Alert Hostname" />;

  return (
    <Field component={TextInput} {...props} label="Alert Hostname" />
  );
}


/**
 * Ticket filters
 */
export function AssignedTo({ ...props }) {
  if (props.renderValue) return <RenderUserFilter values={props.renderValue} label="Assigned To" />;

  return (
    <Field component={UserSelect} {...props} label="Assigned To" multi />
  );
}

export function TicketStatus({ name, ...props }) {
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Ticket Status" options={TICKET_STATUSES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Ticket Status" options={convertArrayToOptions(TICKET_STATUSES)} />;
}

export function TicketType({ name, ...props }) {
  const defaultValues = _.filter(TICKET_TYPES, type => type !== 'Backlog');
  const areDefaultValues = _.isEqual(defaultValues, props.renderValue);

  if (props.renderValue && areDefaultValues) return null;
  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Ticket Types" options={TICKET_TYPES} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Ticket Type" options={convertArrayToOptions(TICKET_TYPES)} />;
}


/**
 * Time report filters
 */
export function CreatedBy(props) {
  if (props.renderValue) return <RenderUserFilter values={props.renderValue} label="Created By" />;

  return (
    <Field component={UserSelect} {...props} label="Created By" multi />
  );
}

export function MultiAgreement({ ...props }) {
  if (props.renderValue) return <RenderFilter value={`(${props.renderValue.length} selected)`} label="Agreements" />;

  // Includes sorted inactive and active agreements and allows multiselection
  return (
    <Field
      component={AgreementSelect}
      {...props}
      label="Agreement"
      setDefaultAgreement={false}
      multi
      groupBy={(options) => _.groupBy(options, (option) => { // eslint-disable-line arrow-body-style
        return (AgreementData.isInactive(option) ? 'Inactive' : 'Active');
      })}
    />
  );
}


/**
 * Billing filters
 */
export function BillingType({ name, ...props }) {
  const options = _.map(['Time Report', 'Billing', 'Expense Bill'], type => ({
    value: _.camelCase(type),
    label: type
  }));

  if (props.renderValue) return <RenderMappedArrayFilter values={props.renderValue} label="Type" options={options} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Type" options={options} />;
}

export function AgreementType({ name, ...props }) {
  const options = ['Monthly', 'Hourly', 'Fixed'];

  if (props.renderValue) return <RenderArrayFilter values={props.renderValue} label="Type" options={options} />;

  return <Field {...props} component={CheckboxGroupInput} name={name} label="Type" options={convertArrayToOptions(options)} />;
}




// WEBPACK FOOTER //
// ./app/components/filters/filter-components.js